import { render, staticRenderFns } from "./HotelDetailsPanel.vue?vue&type=template&id=89d28a44&scoped=true"
import script from "./HotelDetailsPanel.vue?vue&type=script&lang=js"
export * from "./HotelDetailsPanel.vue?vue&type=script&lang=js"
import style0 from "./HotelDetailsPanel.vue?vue&type=style&index=0&id=89d28a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d28a44",
  null
  
)

export default component.exports